import script from "./GestaoUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoUsuarios.vue?vue&type=script&setup=true&lang=js"

import "./GestaoUsuarios.vue?vue&type=style&index=0&id=3b96cb25&lang=css"

const __exports__ = script;

export default __exports__